import equal from "fast-deep-equal"
import { EmptyObject } from "../interfaces"

export const isEqualObjects = equal

export const hasOwnProperty = <T extends object>(
  data: T,
  key: any,
): key is keyof T => {
  return Object.prototype.hasOwnProperty.call(data, key)
}

export const getNotEmptyObjectOrUndefined = <T extends any = any>(
  obj: T | undefined,
): T extends EmptyObject ? undefined : T => {
  return (
    Object.keys(obj ?? {}).length > 0 ? obj : undefined
  ) as T extends EmptyObject ? undefined : T
}

/**
 * Strip empty arrays and nullish values so we never send false filters to the
 * server or store empty values in state.
 */
export const cleanFilters = <T extends object>(filters: T): T =>
  Object.fromEntries(
    Object.entries(filters).filter(([, v]) =>
      Array.isArray(v) ? v.length > 0 : v != null,
    ),
  ) as T

/**
 * Убирает undefined/null/пустые строки из объекта query-параметров,
 * чтобы пустые фильтры не уезжали на сервер.
 */
export const stripUndefined = <T extends object>(obj: T): Partial<T> =>
  Object.fromEntries(
    Object.entries(obj).filter(
      ([, v]) => v !== undefined && v !== null && v !== "",
    ),
  ) as Partial<T>
